// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"400":"2dc79d8145a3ae51","662":"d847953b46b3178d"}[chunkId] + ".js";
};